import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

interface MobilePaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function MobilePagination({
  currentPage,
  totalPages,
  onPageChange,
}: MobilePaginationProps) {
  // Don't show pagination if there's no data or only one page
  if (totalPages <= 1 || totalPages === 0) {
    return null;
  }

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center gap-2 py-4">
      {/* Back Button */}
      <Button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        variant="outline"
        size="sm"
        className="flex items-center gap-1"
      >
        <ChevronLeft className="w-4 h-4" />
        <span>Back</span>
      </Button>

      {/* Page Numbers */}
      <div className="flex items-center gap-1">
        {pages.map((page) => (
          <Button
            key={page}
            onClick={() => onPageChange(page)}
            variant={page === currentPage ? "default" : "outline"}
            size="sm"
            className={`w-8 h-8 p-0 ${
              page === currentPage
                ? "bg-green-600 text-white border-green-600"
                : "bg-white text-gray-600 border-gray-200"
            }`}
          >
            {page}
          </Button>
        ))}
      </div>

      {/* Next Button */}
      <Button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        variant="outline"
        size="sm"
        className="flex items-center gap-1"
      >
        <span>Next</span>
        <ChevronRight className="w-4 h-4" />
      </Button>
    </div>
  );
}
